import * as S from './styles';
const Footer = () => {
  return (
    <S.Container>
      <p>COPYRIGHT BY PLUNGE NO 46. ALL RIGHTS RESERVED.</p>
    </S.Container>
  );
};

export default Footer;
